module.exports = __webpack_public_path__ + "img/coroma-19.8c6322de.png";